<template lang="pug">
  r-table( 
    no-actions
    remind-key='holidays-list'
    v-bind='tableProps' 
    )
</template>

<script>
//
import { RTable } from '@/components/reusable_components/next'
//
import HolidayService from '@/services/api/holiday'
import HolidayHeaders from './partials/headers/HolidaysHeaders'
import HolidayFilters from './partials/filters/holiday'
//
export default {
  components: {
    RTable,
  },
  computed: {
    tableProps() {
      return {
        filters: HolidayFilters,
        headers: HolidayHeaders,
        paramSearch: 'period_year',
        service: HolidayService,
      }
    },
  },
  mounted() {
    this.setTitle('Vacaciones')
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
    })
  },
}
</script>
